var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconVolumeMute48Line = function SvgIconVolumeMute48Line(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m39.2 36.8-28-28-2.4 2.4 6.59 6.59c-1.82.84-3.09 2.67-3.09 4.8v2.8c0 2.92 2.38 5.3 5.3 5.3h2.85l8.65 6.29c.51.37 1.1.56 1.7.56.45 0 .9-.1 1.32-.32.6-.31 1.06-.8 1.32-1.38l3.36 3.36 2.4-2.4Zm-8.9-3.14L22 27.62c-.29-.21-.64-.33-1-.33h-3.4a1.9 1.9 0 0 1-1.9-1.9v-2.8c0-1.05.85-1.9 1.9-1.9h.7l12 12v.97ZM30.3 14.34v9.56l3.4 3.4V13.36c0-1.1-.61-2.09-1.58-2.58-.98-.5-2.13-.41-3.02.24l-6.76 4.92 2.43 2.43 5.53-4.02v-.01Z",
    fill: "current"
  })));
};
export default SvgIconVolumeMute48Line;